import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Body1 } from "common/DS/Text";

const COUNTDOWN_TIME_SECONDS = 30;
const FULL_DASH_ARRAY = 283;

const formatTimeLeft = (time) => {
    let minutes = Math.floor(time / 60);

    let seconds = time % 60;

    if (seconds < 10) {
        seconds = `0${seconds}`;
    }

    if (minutes < 10) {
        minutes = `0${minutes}`;
    }

    return `${minutes}:${seconds}`;
};

const KioskCountDownTimer = ({ isIdle, doReset }, { t: _ }) => {
    const [seconds, setSeconds] = useState(COUNTDOWN_TIME_SECONDS);
    const timeRef = useRef(null);
    const circleDashRef = useRef(null);

    const calculateTime = () => {
        const rawTimeFraction = seconds / COUNTDOWN_TIME_SECONDS;
        return rawTimeFraction - (1 / COUNTDOWN_TIME_SECONDS) * (1 - rawTimeFraction);
    };

    const setCircleDasharray = () => {
        const circleDasharray = `${(calculateTime() * FULL_DASH_ARRAY).toFixed(
            0,
        )} ${FULL_DASH_ARRAY}`;
        circleDashRef.current.setAttribute("stroke-dasharray", circleDasharray);
    };

    useEffect(() => {
        setCircleDasharray();
        if (seconds === 0) doReset();
        timeRef.current = setInterval(() => {
            setSeconds((t) => (t > 0 ? t - 1 : 0));
        }, 1000);

        if (!isIdle) {
            setSeconds(COUNTDOWN_TIME_SECONDS);
        }
        return () => clearInterval(timeRef.current);
    }, [seconds]);

    return (
        <>
            <div className="kiosk-idle-timer__container">
                <Body1>{_("Your session is about to expire and refresh")}</Body1>
            </div>
            <div className="kiosk-idle-timer">
                <svg
                    className="kiosk-idle-timer__svg"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g className="kiosk-idle-timer__circle">
                        <circle className="kiosk-idle-timer__path-elapsed" cx="50" cy="50" r="45" />
                        <path
                            id="kiosk-idle-timer__path-remaining"
                            strokeDasharray={FULL_DASH_ARRAY}
                            ref={circleDashRef}
                            className="kiosk-idle-timer__path-remaining"
                            d="
                            M 50, 50
                            m -45, 0
                            a 45,45 0 1,0 90,0
                            a 45,45 0 1,0 -90,0
                          "
                        />
                    </g>
                </svg>
                <span className="kiosk-idle-timer__label">{formatTimeLeft(seconds)}</span>
            </div>
        </>
    );
};

KioskCountDownTimer.propTypes = {
    isIdle: PropTypes.bool.isRequired,
    doReset: PropTypes.func.isRequired,
};

KioskCountDownTimer.contextTypes = {
    t: PropTypes.func,
};

export default KioskCountDownTimer;
